export default "__VITE_PUBLIC_ASSET__0f9f3a45__"